import React, { useState } from "react";
import styles from "./infomeeting-cards.module.scss";
import { Collapsible } from "@ef-global/web-ui-react";
import styled from "@emotion/styled";

const CollapsedItems = ({
  buttonTextShow = "See more",
  buttonTextHide = "See less",
  buttonTextColor = null,
  children,
}: any): any => {
  const [isExpanded, setExpanded] = useState(false);
  const handleExpanded = () => setExpanded(!isExpanded);

  const CollapsedListContainer = styled.div`
    > div {
      &:last-child {
        span {
          ${buttonTextColor ? `color: ${buttonTextColor} !important;` : ``}
        }
        svg {
          path {
            ${buttonTextColor ? `fill: ${buttonTextColor} !important;` : ``}
          }
        }
      }
    }
  `;

  return (
    <CollapsedListContainer className="ef-col -s-12 u-mt-s">
      <Collapsible.Content expanded={isExpanded}>
        {children}
      </Collapsible.Content>
      <div className={`u-mb-xl u-mt-xl ${styles.customCollapsibleTrigger}`}>
        <Collapsible.Trigger
          icon
          expanded={isExpanded}
          onClick={handleExpanded}
          as={"span"}
        >
          <Collapsible.TextToggle expanded={isExpanded} text={buttonTextHide}>
            {buttonTextShow}
          </Collapsible.TextToggle>
        </Collapsible.Trigger>
      </div>
    </CollapsedListContainer>
  );
};

export default CollapsedItems;
